import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserDataForm from './UserDataForm';

const PrivateRoute = ({ children }) => {
  const { user, loading, showUserForm } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Cargando...</div>;
  }

  // Si el usuario no está autenticado, redirigir a login guardando la ruta actual
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  // Si el usuario necesita completar sus datos, mostrar el formulario
  if (showUserForm) {
    return <UserDataForm />;
  }

  // Si todo está bien, mostrar la ruta protegida
  return children;
};

export default PrivateRoute; 